export default "__VITE_ASSET__89b266e3__"